import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  qty: 0
};

const dialogUnreadSlice = createSlice({
  name: "dialogUnread",
  initialState,
  reducers: {
    setDialogUnreadQty: (state, action) => {
      state.qty = Number(action.payload) || 0;
    }
  }
});

export const { setDialogUnreadQty } = dialogUnreadSlice.actions;

export default dialogUnreadSlice.reducer;
